<template>
    <div class="home">
        <el-container style="height: 100%">
            <el-header style="box-shadow: 0 2px 10px 0 rgba(0 0 0 / 10%)">
                <div class="header">
                    <div class="logoBox" style="width: 200px">
                        <el-image class="logo" :src="require('@/assets/logo2.png')"></el-image>
                        <div class="txt">毛豆随行</div>
                    </div>
                    <i :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'" style="font-size: 20px" @click="collapse"></i>
                    <!-- <div class="breadBox">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item>{{fMenuName}}</el-breadcrumb-item>
                            <el-breadcrumb-item v-if="sMenuName">{{sMenuName}}</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div> -->
                    <el-dropdown class="dropdownBox">
                        <div class="avatarBox">
                            <el-avatar style="width:36px;height:36px;line-height:36px">{{avatar}}</el-avatar>
                            <i class="el-icon-caret-bottom" style="opacity: 0.4;margin-left: 4px"></i>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="changePass">修改密码</el-dropdown-item>
                            <el-dropdown-item divided @click.native="logOut">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>
            <el-container style="width: 100%">
                <el-aside :width="isCollapse?'64px':'200px'" style="height: 100%; background: #545c64;">
                    <LeftMenu :menuData="menuData" :actId="sMenuAct.toString()" :isCollapse="isCollapse" @selectMenu="selectMenu"></LeftMenu>
                </el-aside>
                <el-main class="mainBox">
                    <NavTags :tags="navTags" :actId="sMenuAct" @tagClick="tagClick" @tagClose="tagClose"></NavTags>
                    <el-card class="box-card">
                        <keep-alive :include="cacheList">
                            <router-view />
                        </keep-alive>
                    </el-card>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import LeftMenu from './leftmenu'
import NavTags from './navtags'
import {loginOut, continueSession} from '@/api/login'
import {getUserInfo, getMenuData} from '@/api/common'

export default {
    components: {
        LeftMenu, NavTags
    },
    data(){
        return {
            user: {},
            menuData: [],
            fMenuAct: 0,
            sMenuAct: 0,
            fMenuName: '',
            sMenuName: '',
            navIds: [],//防止重复
            navTags: [],
            cacheList: [],//缓存列表,
            isCollapse: false
        }
    },
    computed: {
        avatar(){
            if(this.user.realname != undefined){
                return this.user.realname.substring(0,1)
            }
        }
    },
    mounted(){
        this.getUser()
        this.getCacheMenu()
        //this.continueSession();
    },
    methods: {
        getUser(){
            let u_token = sessionStorage.getItem("U_TOKEN")
            if(u_token == null){
                u_token = ""
            }
            getUserInfo(u_token).then(res=>{
                if(res.code == 999){
                    sessionStorage.removeItem("U_TOKEN")
                    this.$router.push({name: 'Login'})
                }else{
                    this.user = res.data
                    this.getMenuData()
                }
            })
        },
        getMenuData(){
            getMenuData().then(res=>{
                if(res.code ==1){
                    this.menuData = res.data
                    let actMenu_str = localStorage.getItem("actMenu")
                    if(this.$isNotNull(actMenu_str)){
                        let actMenu = JSON.parse(actMenu_str)
                        this.selectMenu(actMenu)
                    }
                }
            })
        },
        selectMenu(params){
            this.fMenuAct = Number(params.fMenuIndex)
            this.sMenuAct = Number(params.sMenuIndex)
            localStorage.setItem("actMenu", JSON.stringify(params))
            if(this.fMenuAct === 9998){
                //修改密码
                this.fMenuName = '个人设置'
                this.sMenuName = '修改密码'
                let menu = {
                    'id': 9998,
                    'name': '修改密码',
                    'linkurl': '/user/changePass',
                    'pid': 9998,
                    'mdesc': 'changePassword'
                }
                this.addNavTags(menu)
            }if(this.fMenuAct === 0){
                this.fMenuName = ''
                this.sMenuName = ''
            }else{
                for (const index in this.menuData) {
                    if(this.fMenuAct == this.menuData[index].fMenu.id){
                        this.fMenuName = this.menuData[index].fMenu.name
                        const sMenuList = this.menuData[index].sMenuList
                        for (const sIndex in sMenuList) {
                            if(sMenuList[sIndex].id == this.sMenuAct){
                                this.sMenuName = sMenuList[sIndex].name
                                this.addNavTags(sMenuList[sIndex])
                                break
                            }
                        }
                        break
                    }
                }
            }
        },
        addNavTags(menu){
            if(this.navIds.indexOf(menu.id.toString()) >=0){
                return
            }
            this.navIds.push(menu.id.toString())
            let tagItem = {
                'id': menu.id,
                'name': menu.name,
                'linkurl': menu.linkurl,
                'pid': menu.pid,
                'mdesc': menu.mdesc
            }
            this.navTags.push(tagItem)
            this.setCacheList()
        },
        tagClick(params){
            this.sMenuAct = params.tag.id
            let params1 = {
                'fMenuIndex': params.tag.pid,
                'sMenuIndex': params.tag.id,
                'menu': 0
            }
            this.selectMenu(params1)
            this.$router.push({path: params.tag.linkurl})
        },
        tagClose(params){
            let index = params.index
            let tag = this.navTags[index]
            if(this.navTags.length ==1){
                this.fMenuAct = 0
                this.sMenuAct = 0
                this.$router.push({path:'/home'})
                this.fMenuName = ''
                this.sMenuName = ''
                localStorage.removeItem("actMenu")
            }else if(this.sMenuAct == tag.id){
                let o_index = index -1
                if(o_index < 0){
                    o_index = 1
                }
                tag = this.navTags[o_index]
                let params1 = {
                    'fMenuIndex': tag.pid,
                    'sMenuIndex': tag.id,
                    'menu': 0
                }
                this.selectMenu(params1)
                this.$router.push({path: tag.linkurl})
            }
            this.navIds.splice(index, 1)
            this.navTags.splice(index, 1)
            this.setCacheList()
        },
        setCacheList(){
            this.cacheList = []
            let pageList = this.navTags
            if(pageList.length ==0){
                this.cacheList = []
            }else{
                for (const key in pageList) {
                    this.cacheList.push(pageList[key].mdesc)
                }
            }
            this.setCacheMenu()
        },
        setCacheMenu(){
            localStorage.setItem("navTags", JSON.stringify(this.navTags))
            localStorage.setItem("navIds", JSON.stringify(this.navIds))
        },
        getCacheMenu(){
            let navTags_str = localStorage.getItem("navTags")
            if(this.$isNotNull(navTags_str)){
                this.navTags = JSON.parse(navTags_str)
            }
            let navIds_str = localStorage.getItem("navIds")
            if(this.$isNotNull(navIds_str)){
                this.navIds = JSON.parse(navIds_str)
            }
            this.setCacheList()
        },
        changePass(){
            let params = {
                'fMenuIndex': 9998,
                'sMenuIndex': 9998,
                'menu': 0
            }
            this.selectMenu(params)
            this.$router.push({path:'/user/changePass'})
        },
        logOut(){
            loginOut().then(res=>{
                sessionStorage.removeItem("U_TOKEN")
                localStorage.removeItem("actMenu")
                this.$router.push({name:'Login'})
            })
        },
        goHome(){
            let params = {
                'fMenuIndex': 0,
                'sMenuIndex': 0,
                'menu': 0
            }
            this.selectMenu(params)
            this.$router.push({path:'/home'})
        },
        collapse(){//收起左侧菜单
            if(this.isCollapse){
                this.isCollapse = false
            }else{
                this.isCollapse = true
            }
        },
        continueSession(){
            setTimeout(() => {
                this.continueSession1()
            }, 60*1000);
        },
        continueSession1(){
            continueSession().then(res=>{
                this.continueSession()
            })
        },
    },
};
</script>
